import React, { useMemo } from 'react';

import { formatDateString } from '~libs/dayjs';

import { TooltipPortal } from '~components';
import Icon, { faCheck, faXmark } from '~components/icon';

interface ComponentProps {
  id: string;
  row: any;
}

const BudgetIcon: React.FC<ComponentProps> = ({ id, row }) => {
  const { service_type_id, purchase_order_number, client_budget_id } = row || {};

  const matchingService = useMemo(() => {
    const validServices = row?._meta?.validServices ?? [];
    if (!validServices.length) return null;

    if (purchase_order_number) {
      return validServices.find((svc: any) => svc.purchase_order_number === purchase_order_number) ?? null;
    }

    if (service_type_id) {
      return validServices.find((svc: any) => svc.service_type_id === service_type_id) ?? null;
    }

    return null;
  }, [row, purchase_order_number, service_type_id]);

  const budget = matchingService?.budget ?? (client_budget_id ? { id: client_budget_id } : null);
  const { start_date, end_date, reference, status } = budget || {};
  const hasBudget = Boolean(budget?.id);

  // Tooltip & icon
  const indicator = hasBudget ? <Icon icon={faCheck} color="green" /> : <Icon icon={faXmark} color="red" />;

  const tooltipContent = useMemo(() => {
    if (!hasBudget) return 'No budget found';

    if (start_date && end_date) {
      return (
        <div>
          <div>
            Budget found: {formatDateString(start_date)} → {formatDateString(end_date)}
          </div>
          <div>
            Reference: {reference}
            {status && <> (Status: {status})</>}
          </div>
        </div>
      );
    }

    return 'Budget found';
  }, [hasBudget, start_date, end_date, reference, status]);

  return (
    <>
      <div className="d-flex justify-content-center" id={`budget-icon-${id}`}>
        {indicator}
      </div>
      <TooltipPortal targetId={`budget-icon-${id}`} content={tooltipContent} />
    </>
  );
};

export default BudgetIcon;
